module.exports = __webpack_public_path__ + "static/media/score-table-dialog.36c4c192.png";